import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-bod-screen',
  templateUrl: './bod-screen.component.html',
  styleUrls: ['./bod-screen.component.scss']
})
export class BodScreenComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/bod/bod-screen/bod-screen.component.ts